import { requestGet } from "../config/Api";

const BASE = "security/audit";

export const getAuditLogs = (params) => requestGet(BASE, params);
export const getAuditLog = (id) => requestGet(`${BASE}/${id}`);
export const getAuditModules = () => requestGet(`${BASE}/modules`);
export const getAuditActions = () => requestGet(`${BASE}/actions`);
export const getAuditUsers = () => requestGet(`${BASE}/users`);
